// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import type { Store } from 'client/reducers';
import _ from 'lodash';

import { saveUserChoice, setIsVoted } from 'client/actions';
import { setPopUp } from 'client/actions/pop-up';

import VotePopUp from './VotePopUp';

const mapState = (state: Store) => ({
	item: _.get(state, 'item.data'),
	choice: _.get(state, 'choice.list', {}),
	updatedUsersRate: _.get(state, 'choice.lastVotedTotalRate', 0),
	settings: _.get(state, 'settings'),
});

const mapToDispatch = {
	setPopUp,
	saveUserChoice,
	setIsVoted,
};

export default (withRouter(connect(mapState, mapToDispatch)(VotePopUp)): React.AbstractComponent<{}>);
